export function httpMethodInterceptor() {
    const interceptor = {
        request(config: ng.IRequestConfig): ng.IRequestConfig {
            switch (config.method) {
                case 'OPTIONS':
                    // OPTIONS SHOULDN'T BE HANDLED - LET IT THROUGH!
                    break;
                case 'POST':
                case 'GET':
                case 'DELETE':
                    // POST and GET are allowed.  Everything else must be "spoofed" to get around DuPont Pioneer rules
                    break;
                default:
                    config.headers['X-HTTP-Method'] = config.method;
                    config.method = 'POST';
                    break;
            }
            return config;
        }
    };
    return interceptor;
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/httpMethodInterceptor.ts
 **/